import React from "react";

import * as Styles from "./message.styles";

interface Props {
  text?: string;
}

const Message: React.FC<Props> = ({ text }) => {
  return (
    <Styles.Container>
      <Styles.Text>{text}</Styles.Text>
    </Styles.Container>
  );
};

Message.defaultProps = {
  text: "",
};

export default Message;
